"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
var fetch_jsonp_1 = __importDefault(require("fetch-jsonp"));
var urlMethod_1 = require("./urlMethod");
var _a = require("abortcontroller-polyfill/dist/cjs-ponyfill"), AbortController = _a.AbortController, abortableFetch = _a.abortableFetch;
var request = function (url, data, dataType, _a) {
    if (dataType === void 0) { dataType = "json"; }
    var _b = _a === void 0 ? {} : _a, _c = _b.method, method = _c === void 0 ? "GET" : _c, _d = _b.isCors, isCors = _d === void 0 ? false : _d, _e = _b.timeout, timeout = _e === void 0 ? 10000 : _e, _f = _b.paramsType, paramsType = _f === void 0 ? "json" : _f, _g = _b.needEncode, needEncode = _g === void 0 ? true : _g, 
    // 是否在请求的时候需要传递cookie
    _h = _b.isCookie, 
    // 是否在请求的时候需要传递cookie
    isCookie = _h === void 0 ? false : _h, 
    // 自定义的header信息
    _j = _b.autoHeaders, 
    // 自定义的header信息
    autoHeaders = _j === void 0 ? {} : _j;
    var controller = new AbortController();
    var signal = controller.signal;
    var timeoutPromise = function () {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (typeof Response == 'undefined') {
                    resolve({ status: 504, statusText: "timeout " });
                }
                else {
                    resolve(new Response("timeout", { status: 504, statusText: "timeout " }));
                }
                controller.abort();
            }, timeout);
        });
    };
    var requestPromise = function () {
        var pattern = /^(http[s]?:)?\/\//i;
        if (!pattern.test(url)) {
            url = "//" + window.location.hostname + url;
        }
        if (Object.prototype.toString.call(data) === "[object Object]" &&
            typeof data != "string" &&
            typeof data.rand == "undefined") {
            data.rand = new Date().getTime();
        }
        if (method.toLowerCase() == "post") {
            var bodyData = "";
            var contentType = "";
            // application/json
            if (paramsType.toLocaleLowerCase() == "json") {
                contentType = "application/json";
                bodyData = JSON.stringify(data);
                // formdata会自动添加contenttype multipart/form-data; boundary=----WebKitFormBoundarybCvK9U2pvIwAA30K 会自动携带
            }
            else if (paramsType.toLocaleLowerCase() == "formdata") {
                if (Object.prototype.toString.call(data) === "[object Object]" &&
                    typeof data != "string") {
                    bodyData = objToFormData(data);
                }
                else if (typeof data == "string") {
                    bodyData = data;
                }
                // application/x-www-form-urlencoded
            }
            else if (paramsType.toLocaleLowerCase() == "urlencoded") {
                contentType = "application/x-www-form-urlencoded";
                bodyData = String(data);
            }
            var fetchConfig = {
                method: 'post',
                body: bodyData,
                mode: isCors ? 'cors' : 'no-cors',
                // 是否携带cookie
                headers: __assign({}, autoHeaders),
            };
            // 是否在请求的时候需要携带cookie
            if (isCookie) {
                fetchConfig = __assign(__assign({}, fetchConfig), { credentials: "include" });
            }
            if (paramsType.toLocaleLowerCase() !== 'formdata') {
                fetchConfig.headers = __assign(__assign({}, fetchConfig.headers), { 'Content-Type': contentType });
            }
            return fetch(url, __assign({}, fetchConfig));
        }
        else {
            // get请求
            var str = Object.prototype.toString.call(data) === "[object Object]"
                ? urlMethod_1.setUrlParam({ url: url, params: data, needEncode: needEncode })
                : url;
            if (typeof dataType != "undefined" &&
                dataType.toLocaleLowerCase() == "jsonp") {
                // jsonp请求
                return fetch_jsonp_1.default(str, {
                    // @ts-ignore
                    signal: signal,
                    timeout: timeout
                });
            }
            else {
                var fetchConfig = {
                    method: method.toUpperCase(),
                    headers: __assign({}, autoHeaders),
                    mode: isCors ? 'cors' : 'no-cors',
                };
                if (isCookie) {
                    fetchConfig = __assign(__assign({}, fetchConfig), { credentials: "include" });
                }
                // json请求
                return fetch(str, __assign({}, fetchConfig));
            }
        }
    };
    return new Promise(function (resolve, reject) {
        Promise.race([timeoutPromise(), requestPromise()]).then(function (resp) {
            // @ts-ignore
            if (resp.status == 504) {
                reject("超时");
                // @ts-ignore
            }
            else if (typeof resp == "undefined") {
                reject("没有返回值");
            }
            else {
                // @ts-ignore
                resolve(resp.json());
            }
        }, function (error) {
            reject(error);
        });
    });
};
exports.request = request;
// 对象转formdata格式
function objToFormData(data) {
    var formData = new FormData();
    Object.keys(data).map(function (key) {
        // 如果值是一个数组
        if (Object.prototype.toString.call(data[key]) === "[object Array]") {
            data[key].forEach(function (item, i) {
                if (typeof item == "object") {
                    for (var k in item) {
                        formData.append(key + "[" + i + "]." + k, item[k]);
                    }
                }
                else {
                    formData.append(key + "[" + i + "]", item);
                }
            });
        }
        else {
            formData.append(key, data[key]);
        }
    });
    return formData;
}
